(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["car-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-car-finder]').forEach(function (sel) {
  sel.addEventListener('change', function () {
    if (!sel.value) return;
    var base = (sel.getAttribute('data-base') || '').replace(/\/+$/, '');
    window.location.href = base + '/' + sel.value;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-q').forEach(function (b) {
  b.addEventListener('click', function () {
    var item = b.parentElement;
    var ans = item.querySelector('.faq-a');
    var open = item.classList.toggle('open');
    if (ans) ans.style.maxHeight = open ? (ans.scrollHeight + 'px') : '0';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('product-recommendations');
          // Only replace the fallback if the API actually returned products.
          if (fresh && fresh.innerHTML.trim().length) {
            this.innerHTML = fresh.innerHTML;
          }
        }.bind(this))
        .catch(function () {});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
